import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { NotifyService } from '@app/services';
import { ApplicantMessageTemplate } from '@models/recruiting/applicant-message-template.model';
import { StoreView } from '@common/views';
import { BaseForm } from '@forms/base.form';
import { ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: './applicant-message-template-store.template.html',
})
export class ApplicantMessageTemplateStoreView extends StoreView {
    isLoading = false;
    title = 'applicant-tracker.createAnEmailTemplate';
    applicantMessageTemplate: ApplicantMessageTemplate = new ApplicantMessageTemplate();

    constructor(
        private notify: NotifyService,
        private location: Location,
        private route: ActivatedRoute
    ) {
        super();

        if (this.route.snapshot.data.models) {
            this.title = 'applicant-tracker.editAnEmailTemplate';
            this.applicantMessageTemplate = this.route.snapshot.data.models.get('applicantMessageTemplate');
        }
    }

    onSave(applicantMessageTemplateForm: BaseForm): void {
        applicantMessageTemplateForm.submit();

        if (!applicantMessageTemplateForm.valid) {
            return;
        }

        this.isLoading = true;

        this.applicantMessageTemplate
            .save()
            .then(() => {
                this.location.back();
                this.notify.success('applicant-tracker.applicantMessageTemplateSaved');
            })
            .catch((err) => {
                this.notify.error(err.message);
                this.isLoading = false;
            });
    }
}
